import "./menuPage.scss";
import React from "react";
import { Link } from "react-router-dom";
import SiteHeader from "../layout/SiteHeader";
import menu_p1 from "./menu1.png";
import menu_p2 from "./menu2.png";
import menu_p3 from "./liga_menu_p_3_mid.png";
import menu_p4 from "./liga_menu_p_4_mid.png";

const MENU_PAGES = [
  { src: menu_p1, alt: "Страница меню 1" },
  { src: menu_p2, alt: "Страница меню 2" },
  { src: menu_p3, alt: "Страница меню 3" },
  { src: menu_p4, alt: "Страница меню 4" },
];

const MenuPage = () => {
  return (
    <div className="menu-book">
      <SiteHeader tagline="Меню бара и кухни" />

      <section className="menu-book__intro">
        <div className="container menu-book__intro-inner">
          <p className="section-label">Открытая подача</p>
          <h1 className="menu-book__title">Меню «ЛИГА»</h1>
          <p className="menu-book__subtitle">
            Здесь представлены те же позиции, что подаются в клубе. Для заказа к
            столу или бронирования — звоните администратору с главной страницы.
          </p>
          <Link className="menu-book__back" to="/">
            ← На главную
          </Link>
        </div>
      </section>

      <section className="menu-book__pages">
        <div className="container menu-book__pages-inner">
          {MENU_PAGES.map((page, i) => (
            <figure key={`menu-page-${i}`} className="menu-book__figure">
              <img src={page.src} alt={page.alt} loading={i === 0 ? "eager" : "lazy"} />
            </figure>
          ))}
        </div>
      </section>
    </div>
  );
};

export default MenuPage;
